const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const BattleConfig = require('../../../constants/BattleConfig');
const CCHandler = require('../../CCHandler');
const SlowedCondition = require('../../conditions/SlowedCondition');
const IceProcEvent = require('../../events/IceProcEvent');
const { logError } = require('../../logger');
const { getAbilityLevel } = require('../../../isomorphic-helpers');

const IceNine = function (battleState) {
  this.handle = 'ice_nine';
  this.ranged = true;
  this.harm = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = () => true;

  this.execute = function (actor, victim, isProc = false) {
    if (!actor || !actor.inPlay || !victim || (victim.unit && !victim.inPlay)) {
      return { success: false };
    }

    setTimeout(() => {
      try {
        if (
          !actor ||
          !actor.inPlay ||
          !victim ||
          (victim.unit && !victim.inPlay)
        ) {
          return;
        }

        var result = onThrowDelay(actor, victim, isProc);
        result.abilityHandle = this.handle;
        result.actorId = actor.uid;
        result.victimId = victim.uid;
        result.allPieces = battleState.allPieces;

        this.eventEmitter.emit('result', result);
      } catch (err) {
        logError(err, {
          module: 'IceNine',
          func: 'execute',
          actor,
          victim,
          isProc,
        });
      }
    }, BattleCalc.projectileTime(BattleConfig.THROWN_SPEED, actor, victim));
  };

  function onThrowDelay(actor, victim, isProc) {
    var result = {
      slowedConditions: [],
      success: false,
      isProc,
    };

    if (!battleState || !battleState.allUnits) {
      return result;
    }

    result.victims = [];

    const ability = BattleCalc.getEquippedAbility(actor, 'ice_nine');
    const ability_level = ability
      ? getAbilityLevel({ ability_handle: ability.handle, unit_build: actor })
      : 0;
    var numJumps = isProc
      ? Math.min(7, Math.floor(actor.level / 7))
      : ability_level;
    const duration = isProc
      ? 2000 + 7000 * (actor.level / 50)
      : ability.duration;

    var _uVictim = victim.unit ? victim : findNewVictim(actor, victim);

    for (var i = 0; i < numJumps; ++i) {
      if (!_uVictim) {
        break;
      }

      result.victims.push(_uVictim);
      _uVictim.hitByIceNine = true;

      new IceProcEvent(battleState, _uVictim).execute();

      if (!CCHandler.checkForResistSlow(_uVictim, battleState)) {
        var slowed = new SlowedCondition(
          actor,
          _uVictim,
          battleState,
          duration
        );
        slowed.instigatorId = actor.uid;
        slowed.ownerId = _uVictim.uid;
        battleState.onUnitCondition(slowed);
        result.slowedConditions.push(slowed);
      }
      _uVictim = findNewVictim(actor, _uVictim);
    }

    if (result.victims.length > 0) {
      result.success = true;
    }

    return result;
  }

  function findNewVictim(actor, oldVictim) {
    var potentialVictims = findVictims(actor, oldVictim);

    if (potentialVictims.length === 0) {
      return null;
    }

    return potentialVictims[
      Math.round(Math.random() * potentialVictims.length)
    ];
  }

  function findVictims(actor, oldVictim) {
    var potentialVictims = [];
    var dist;
    var adjacentVictim = false;
    for (var prop in battleState.allUnits) {
      var unit = battleState.allUnits[prop];
      dist = BattleCalc.boardDistance(oldVictim, unit);

      if (
        dist <= 2 &&
        unit.team != actor.team &&
        !unit.hitByIceNine &&
        unit != actor &&
        !BattleCalc.tileBetweenThemIsOccupied(oldVictim, unit, battleState)
      ) {
        potentialVictims.push(unit);
        if (dist === 1) {
          adjacentVictim = true;
        }
      }
    }

    if (adjacentVictim) {
      potentialVictims = BattleCalc.clearDistTwoVictims(
        oldVictim,
        potentialVictims
      );
    }

    return potentialVictims;
  }
};
module.exports = IceNine;
